// extracted by mini-css-extract-plugin
export default {"advice":"styles_advice__UA6SR","header":"styles_header__67DAi","text":"styles_text__DsVdP"};